function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// Drawer menu main navigation

requestAnimationFrame(() => {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');

    if(summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    // Initialize icon visibility based on initial state
    const details = summary.closest('details');
    const plusIcon = summary.querySelector('.collapse-icon-plus');
    const minusIcon = summary.querySelector('.collapse-icon-minus');

    if (plusIcon && minusIcon) {
      if (details.hasAttribute('open')) {
        // Details starts open
        plusIcon.classList.add('hidden');
        minusIcon.classList.remove('hidden');
        summary.setAttribute('aria-expanded', 'true');
      } else {
        // Details starts closed
        plusIcon.classList.remove('hidden');
        minusIcon.classList.add('hidden');
        summary.setAttribute('aria-expanded', 'false');
      }
    }

    summary.addEventListener('click', (event) => {
      const details = event.currentTarget.closest('details');
      const isOpen = details.hasAttribute('open');

      event.currentTarget.setAttribute('aria-expanded', !isOpen);

      // Toggle icon visibility
      const plusIcon = summary.querySelector('.collapse-icon-plus');
      const minusIcon = summary.querySelector('.collapse-icon-minus');

      if (plusIcon && minusIcon) {
        if (isOpen) {
          // Details is currently open, will be closed after click
          plusIcon.classList.remove('hidden');
          minusIcon.classList.add('hidden');
        } else {
          // Details is currently closed, will be opened after click
          plusIcon.classList.add('hidden');
          minusIcon.classList.remove('hidden');
        }
      }
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
    
  });
  
  // Track mouse velocity for hover detection
  let mouseVelocityTracker = {
    lastX: null,
    lastY: null,
    lastTime: null,
    velocities: [],
    maxVelocityHistory: 5
  };
  
  // Track mouse movement to calculate velocity
  document.addEventListener('mousemove', (event) => {
    const now = Date.now();
    
    if (mouseVelocityTracker.lastX !== null && mouseVelocityTracker.lastY !== null && mouseVelocityTracker.lastTime !== null) {
      const deltaX = event.clientX - mouseVelocityTracker.lastX;
      const deltaY = event.clientY - mouseVelocityTracker.lastY;
      const deltaTime = now - mouseVelocityTracker.lastTime;
      
      if (deltaTime > 0) {
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const velocity = distance / deltaTime; // pixels per millisecond
        
        // Store velocity in history
        mouseVelocityTracker.velocities.push(velocity);
        if (mouseVelocityTracker.velocities.length > mouseVelocityTracker.maxVelocityHistory) {
          mouseVelocityTracker.velocities.shift();
        }
      }
    }
    
    mouseVelocityTracker.lastX = event.clientX;
    mouseVelocityTracker.lastY = event.clientY;
    mouseVelocityTracker.lastTime = now;
  });
  
  // Velocity threshold: pixels per millisecond (adjust as needed)
  // Lower value = more sensitive (requires slower movement)
  // Higher value = less sensitive (allows faster movement)
  const VELOCITY_THRESHOLD = 0.5; // pixels per millisecond
  
  // Add hover functionality for header dropdown menus
  document.querySelectorAll('nav.header__inline-menu header-menu').forEach((headerMenu) => {
    const details = headerMenu.querySelector('details[id^="Details-HeaderMenu-"]');
    const summary = details?.querySelector('summary');
    const submenu = details?.querySelector('.header__submenu');
    
    if (!details || !summary) return;
    
    let hoverTimeout;
    let openTimeout;
    let isMenuOpen = false;
    
    // Function to open the menu
    const openMenu = () => {
      if (isMenuOpen) return;

      const nav = headerMenu.closest('nav.header__inline-menu');
      if (nav) {
        // Close other top-level menus first
        nav.querySelectorAll('details[id^="Details-HeaderMenu-"]').forEach((otherDetails) => {
          if (otherDetails !== details) {
            const otherSummary = otherDetails.querySelector('summary');
            otherDetails.removeAttribute('open');
            if (otherSummary) {
              otherSummary.setAttribute('aria-expanded', 'false');
              // Update icon visibility for closed menu
              const plusIcon = otherSummary.querySelector('.collapse-icon-plus');
              const minusIcon = otherSummary.querySelector('.collapse-icon-minus');
              if (plusIcon && minusIcon) {
                plusIcon.classList.remove('hidden');
                minusIcon.classList.add('hidden');
              }
            }
          }
        });
      }

      // Force animation reset by temporarily adding a class, then removing it
      // This ensures the animation triggers every time by restarting the CSS animation
      if (submenu) {
        submenu.classList.add('menu-animating');
        const items = submenu.querySelectorAll('li');
        items.forEach(item => item.classList.add('menu-animating'));

        // Force reflow to ensure browser recognizes the state change
        void submenu.offsetHeight;

        requestAnimationFrame(() => {
          submenu.classList.remove('menu-animating');
          items.forEach(item => item.classList.remove('menu-animating'));
        });
      }

      // Open current menu
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
      isMenuOpen = true;

      // Update icon visibility
      const plusIcon = summary.querySelector('.collapse-icon-plus');
      const minusIcon = summary.querySelector('.collapse-icon-minus');
      if (plusIcon && minusIcon) {
        plusIcon.classList.add('hidden');
        minusIcon.classList.remove('hidden');
      }
    };
    
    // Function to animate menu items sequentially
    const animateMenuItemsSequentially = (submenuElement) => {
      if (!submenuElement) {
        return;
      }
      
      // Validate that submenuElement is actually an Element
      if (!(submenuElement instanceof Element)) {
        return;
      }
      
      // Check for reduced motion preference
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) {
        return;
      }
      
      // Get all top-level menu items (direct children li elements)
      // Use children property for better browser compatibility
      let items = [];
      try {
        if (submenuElement.children && submenuElement.children.length > 0) {
          items = Array.from(submenuElement.children).filter(child => child.tagName === 'LI');
        } else {
          // Fallback: try querySelectorAll without the > combinator
          items = Array.from(submenuElement.querySelectorAll('li')).filter((li, index, arr) => {
            // Only include direct children
            return li.parentElement === submenuElement;
          });
        }
      } catch (error) {
        return;
      }
      
      if (items.length === 0) {
        return;
      }
      
      // Set all items to invisible first (they should already be 0 from CSS, but ensure it)
      items.forEach((item) => {
        // Set initial state - make sure transition is set before changing opacity
        // Use shorter transition for smoother animation
        item.style.transition = 'opacity 0.6s ease';
        item.style.opacity = '0';
        
        // Force a reflow to ensure the browser recognizes the initial state
        void item.offsetHeight;
      });
      
      // Wait for layout to be calculated, then sort by position
      setTimeout(() => {
        // Get positions after layout is calculated
        const itemsWithPosition = items.map((item, index) => {
          const rect = item.getBoundingClientRect();
          return {
            element: item,
            top: rect.top,
            left: rect.left,
            originalIndex: index
          };
        });
        
        // Calculate if items wrap into multiple rows
        const topPositions = itemsWithPosition.map(item => item.top);
        const minTop = Math.min(...topPositions);
        const maxTop = Math.max(...topPositions);
        const hasMultipleRows = (maxTop - minTop) > 10; // More than 10px difference means multiple rows
        
        // Sort by top position first, then by left position
        // For top-to-bottom: prioritize vertical position strongly
        itemsWithPosition.sort((a, b) => {
          const topDiff = a.top - b.top;
          // Always sort by vertical position first (top to bottom)
          // If there's any difference in vertical position, prioritize it
          if (Math.abs(topDiff) > 0.5) {
            return topDiff; // Top to bottom - even small differences matter
          }
          // Only if items are at exactly the same vertical position, sort by horizontal
          return a.left - b.left;
        });
        
        // Animate items in sorted order (top to bottom)
        itemsWithPosition.forEach((itemData, index) => {
          // Apply sequential delay (each item appears 150ms after the previous)
          setTimeout(() => {
            if (itemData.element && itemData.element.parentElement) { // Check if item still exists
              // Set opacity to 1 - inline style will override CSS
              itemData.element.style.opacity = '1';
            }
          }, index * 150 + 150); // 150ms initial delay + 150ms per item (slower)
        });
      }, 100); // Wait longer for layout to be fully calculated and rendered
      
      // Fallback: ensure all items are visible after animation completes
      const totalDuration = items.length * 150 + 800; // 800ms for last animation + buffer (increased)
      setTimeout(() => {
        items.forEach(item => {
          if (item && item.style.opacity === '0') {
            item.style.opacity = '1';
          }
        });
      }, totalDuration);
    };
    
    // Function to reset menu item animations
    const resetMenuItemsAnimation = (submenuElement) => {
      if (!submenuElement || !submenuElement.querySelectorAll) {
        return;
      }
      
      try {
        // Use children property or a safer selector
        const items = Array.from(submenuElement.children).filter(child => child.tagName === 'LI');
        items.forEach(item => {
          if (item && item.style) {
            // Reset to hidden state - CSS will handle the rest
            item.style.opacity = '0';
            item.style.transition = '';
            // Remove inline styles after a brief moment to let CSS take over
            setTimeout(() => {
              if (item && item.style) {
                item.style.opacity = '';
              }
            }, 100);
          }
        });
      } catch (error) {
      }
    };
    
    // Function to close the menu
    const closeMenu = () => {
      if (!isMenuOpen) return;

      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
      isMenuOpen = false;

      // CSS handles the animation reset automatically

      // Update icon visibility
      const plusIcon = summary.querySelector('.collapse-icon-plus');
      const minusIcon = summary.querySelector('.collapse-icon-minus');
      if (plusIcon && minusIcon) {
        plusIcon.classList.remove('hidden');
        minusIcon.classList.add('hidden');
      }
    };
    
    // Open menu on mouseenter (only if moving slowly)
    headerMenu.addEventListener('mouseenter', () => {
      
      // Clear any pending close timeout
      clearTimeout(hoverTimeout);
      clearTimeout(openTimeout);
      
      // Check velocity before opening (use recent velocity from before entering)
      const recentVelocity = mouseVelocityTracker.velocities.length > 0 
        ? mouseVelocityTracker.velocities[mouseVelocityTracker.velocities.length - 1] 
        : 0;
      
      // If menu is already open, keep it open
      if (isMenuOpen) {
        // Reset velocity tracker now that we're in the menu area
        mouseVelocityTracker.velocities = [];
        return;
      }
      
      // Reset velocity tracker when entering menu area to avoid carryover from fast movement
      // But check velocity first before resetting
      const shouldOpen = recentVelocity <= VELOCITY_THRESHOLD;
      mouseVelocityTracker.velocities = [];
      
      // If moving too fast, add a small delay to check again
      if (!shouldOpen) {
        openTimeout = setTimeout(() => {
          // Check if mouse is still in the menu area and velocity has decreased
          const checkVelocity = mouseVelocityTracker.velocities.length > 0 
            ? mouseVelocityTracker.velocities[mouseVelocityTracker.velocities.length - 1] 
            : 0;
          if (checkVelocity <= VELOCITY_THRESHOLD) {
            openMenu();
          } else {
            return;
          }
        }, 80); // Short delay to confirm slow movement
      } else {
        // Moving slowly, open immediately
        openMenu();
      }
    });
    
    // Also add mouseenter to submenu to keep menu open
    if (submenu) {
      submenu.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimeout);
        clearTimeout(openTimeout);
        if (!isMenuOpen) {
          openMenu();
        }
      });
    }
    
    // Close menu on mouseleave (with delay to allow moving to submenu)
    headerMenu.addEventListener('mouseleave', (event) => {
      // Check if we're moving to the submenu
      const relatedTarget = event.relatedTarget;
      if (relatedTarget && (submenu?.contains(relatedTarget) || headerMenu.contains(relatedTarget))) {
        return;
      }
      
      // Clear open timeout if menu hasn't opened yet
      clearTimeout(openTimeout);
      
      // Delay closing to allow moving to submenu
      hoverTimeout = setTimeout(() => {
        closeMenu();
      }, 200); // Increased delay to allow moving to submenu
    });
    
    // Also handle mouseleave on submenu
    if (submenu) {
      submenu.addEventListener('mouseleave', (event) => {
        // Check if we're moving back to the summary
        const relatedTarget = event.relatedTarget;
        if (relatedTarget && (summary.contains(relatedTarget) || headerMenu.contains(relatedTarget))) {
          return;
        }
        
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(() => {
          closeMenu();
        }, 150);
      });
    }
  });
});

// TO-DO: Research focus trap
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function playProductVideoMedia() {
  if (document.querySelector('.product__media--video video')) {
    document.querySelectorAll('.product__media--video video').forEach((video) => video.play());
  }
}

// Video IntersectionObserver for viewport-based playback control
let videoIntersectionObserver = null;

function initVideoIntersectionObserver() {
  // Prevent running in the homepage
  if (window.location.pathname === '/') return;

  const videos = document.querySelectorAll('video');
  
  // Create intersection observer if it doesn't exist
  if (!videoIntersectionObserver) {
    videoIntersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(() => {}); // prevent errors
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.5 }); // play when at least 50% visible
  }

  // Observe all existing videos
  videos.forEach(video => {
    if (!video.dataset.intersectionObserved) {
      videoIntersectionObserver.observe(video);
      video.dataset.intersectionObserved = 'true';
    }
  });

  // Watch for dynamically added videos
  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the added node is a video
          if (node.tagName === 'VIDEO' && !node.dataset.intersectionObserved) {
            videoIntersectionObserver.observe(node);
            node.dataset.intersectionObserved = 'true';
          }
          // Check for videos within the added node
          const videosInNode = node.querySelectorAll && node.querySelectorAll('video');
          if (videosInNode) {
            videosInNode.forEach(video => {
              if (!video.dataset.intersectionObserved) {
                videoIntersectionObserver.observe(video);
                video.dataset.intersectionObserved = 'true';
              }
            });
          }
        }
      });
    });
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);

  // Toggle icon visibility when closing via ESC
  const plusIcon = summaryElement.querySelector('.collapse-icon-plus');
  const minusIcon = summaryElement.querySelector('.collapse-icon-minus');

  if (plusIcon && minusIcon) {
    plusIcon.classList.remove('hidden');
    minusIcon.classList.add('hidden');
  }

  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })
    this.moq = this.dataset.moq;
    this.qtyError = this.querySelector(".error");

    if (this.moq) {
      this.input.addEventListener('input', this.onInputEvent.bind(this));
      if (this.input.value == parseInt(this.moq)) {
        this.querySelector("[name='minus']").classList.add("disabled");
      }
    }

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onInputEvent() {
    if (this.input.value < parseInt(this.moq)) {
      this.querySelector("[name='minus']").classList.add("disabled");
      this.qtyError.classList.remove("hidden");
      this.input.value = parseInt(this.moq);
    } else {
        if(this.input.value != parseInt(this.moq)) {
          this.querySelector("[name='minus']").classList.remove("disabled");
        }
        this.qtyError.classList.add("hidden");
    }
  };

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if (this.moq) {
      this.qtyError.classList.add("hidden");
      this.querySelector("[name='minus']").removeAttribute("disabled");
      if (event.target.name === "minus" && this.input.value == parseInt(this.moq)) {
        this.input.value == parseInt(this.moq) ? this.querySelector("[name='minus']").classList.add("disabled") : this.querySelector("[name='minus']").classList.remove("disabled");
        this.qtyError.classList.remove("hidden");
      } else {
        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
        this.qtyError.classList.add("hidden");
        this.querySelector("[name='minus']").classList.remove("disabled");
      }
      if (this.input.value == parseInt(this.moq)) {
        this.querySelector("[name='minus']").classList.add("disabled");
      }
    } else {
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll('.mobile-facets__close').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      // Only toggle if not already open, to preserve initial state
      if (!isOpen) {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches
            ? addTrapFocus()
            : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    const menuDrawerTest = document.querySelector('#menu-drawer');
      menuDrawerTest.style.transform = "translateX(+100%)";
      menuDrawerTest.style.opacity = "0";

    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    
    const rightMenu = document.querySelector('.header__icons');
      rightMenu.addEventListener('click', this.onMenuClick.bind(this));
  }
  
  onMenuClick(event) {
    // if cart link or drawer trigger, ignore stopPropagation and preventDefault to allow drawer-cart.js to handle it
    const cartIcon = event.target.closest('#cart-icon-bubble');
    const drawerTrigger = event.target.closest('[data-drawer-trigger]');

    if (cartIcon || drawerTrigger || event.target.parentElement.classList.contains('cart-count-bubble')) {
      return;
    }
    event.stopPropagation();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    const menuDrawerTest = document.querySelector('#menu-drawer');
      menuDrawerTest.style.transform = "translateX(0)";
      menuDrawerTest.style.opacity = "1";

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');

      // Find all details that are already open (active categories)
      const openDetails = Array.from(this.mainDetailsToggle.querySelectorAll('details[open]')).filter(
        (details) => details !== this.mainDetailsToggle
      );

      // Find the deepest nested open details element (most specific category)
      let deepestDetails = null;
      let maxDepth = -1;

      openDetails.forEach((details) => {
        // Count how many parent details elements this has
        let depth = 0;
        let parent = details.parentElement;
        while (parent) {
          if (parent.tagName === 'DETAILS' && parent !== this.mainDetailsToggle) {
            depth++;
          }
          parent = parent.parentElement;
        }
        if (depth > maxDepth) {
          maxDepth = depth;
          deepestDetails = details;
        }
      });

      // If we found a deepest details element, keep only that one open
      if (deepestDetails) {
        // Close all other open details except the deepest one and its ancestors
        openDetails.forEach((details) => {
          if (details !== deepestDetails && !deepestDetails.closest(`#${details.id}`)) {
            details.removeAttribute('open');
            details.classList.remove('menu-opening');
            const summary = details.querySelector('summary');
            if (summary) {
              summary.setAttribute('aria-expanded', 'false');
            }
          }
        });

        // Now process only the deepest details and its ancestors
        let currentDetails = deepestDetails;
        while (currentDetails && currentDetails !== this.mainDetailsToggle) {
          if (currentDetails.tagName === 'DETAILS' && currentDetails.hasAttribute('open')) {
            currentDetails.classList.add('menu-opening');
            const summary = currentDetails.querySelector('summary');
            if (summary) {
              summary.setAttribute('aria-expanded', 'true');
            }

            // Add submenu-open class to parent menu to hide it
            const parentMenuElement = currentDetails.closest('.has-submenu');
            if (parentMenuElement) {
              parentMenuElement.classList.add('submenu-open');
            }
          }
          currentDetails = currentDetails.parentElement?.closest('details');
        }
      }

      menuDrawerTest.style.transition = "transform 400ms ease-in-out";
      menuDrawerTest.style.transform = "translateX(0)";
    }, 10);

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.playProductVideoMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    //window.pauseAllMedia();
    console.log('loadContent', this);
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.isDown = false;
    this.leaveSlider = true;

    this.startX;
    this.scrollLeft;
    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.slider.addEventListener('mousedown', this.mouseDown.bind(this));
    this.slider.addEventListener('mouseleave', this.mouseLeave.bind(this));
    this.slider.addEventListener('mouseup', this.mouseUp.bind(this));
    window.addEventListener('resize', this.resizeScreen.bind(this));
  }

  resizeScreen() {
    const mediaQuery = window.matchMedia("(min-width: 750px)");
    if (mediaQuery.matches) { 
      this.slider.scrollTo({
        left: 0
      });
    }
  }

  mouseDown (e) {
    this.isDown = true;
    this.slider.classList.add('active');
    this.startX = e.pageX - this.slider.offsetLeft;
    this.scrollLeft = this.slider.scrollLeft;
  }

  mouseLeave () {
    this.isDown = false;
    this.slider.classList.remove('active');
  }

  mouseUp (e) {
    if(!this.isDown) return;

    const x = e.pageX - this.slider.offsetLeft;
    const walk = (x - this.startX) * 3;
    const direction = this.scrollLeft - walk;

    if (direction < -50){
      this.prevButton.click();
    } else if (direction > 50) {
      this.nextButton.click();
    } else {
      this.sliderItems.forEach(el => {
        el.addEventListener('click', function() {
          const dataHref = this.getAttribute("data-href");
          if (dataHref != null) {
            document.location.href = this.getAttribute("data-href");
          }
        });
      });
    }
    this.slider.classList.remove('active')
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
    this.leaveSlider = true;
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    const mediaQuery = window.matchMedia("(min-width: 750px)");
    if (mediaQuery.matches) { 
      this.play();
      this.autoplayButtonIsSetToPlay = true;
    } else {
      if (this.classList.contains("slideshow--1-view")) {
        this.play();
        this.autoplayButtonIsSetToPlay = true;
      } else {
        this.autoplayButtonIsSetToPlay = false;
      }
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    var isLastSlide = this.currentPage === this.sliderItemsToShow.length;
    const mediaQuery = window.matchMedia("(min-width: 750px)");
    if (mediaQuery.matches) { 
      if (this.classList.contains("slideshow--1-view")) {
        var isLastSlide = this.currentPage === this.sliderItemsToShow.length;
      } else if (this.classList.contains("slideshow--2-view")){
        var isLastSlide = this.currentPage === Math.ceil(this.sliderItemsToShow.length - 1);
      } else if (this.classList.contains("slideshow--3-view")){      
        var isLastSlide = this.currentPage === Math.ceil(this.sliderItemsToShow.length - 2);
      } else if (this.classList.contains("slideshow--4-view")){      
        var isLastSlide = this.currentPage === Math.ceil(this.sliderItemsToShow.length - 3);
      } else if (this.classList.contains("slideshow--5-view")){      
        var isLastSlide = this.currentPage === Math.ceil(this.sliderItemsToShow.length - 4);
      } else {
        var isLastSlide = this.currentPage === this.sliderItemsToShow.length;
      }
    }

    

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      this.slider.classList.add('to-first-slide');      
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
      this.slider.classList.add('to-first-slide');      
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');
    this.slider.classList.remove('to-first-slide');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const mediaQuery = window.matchMedia("(min-width: 750px)");
    if (mediaQuery.matches) { 
      if (this.classList.contains("slideshow--1-view")) {
        var slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
      } else if (this.classList.contains("slideshow--2-view")){
        var slideScrollPosition = this.currentPage === this.sliderItems.length - 1 ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth * 2;
      } else if (this.classList.contains("slideshow--3-view")){
        var slideScrollPosition = this.currentPage === this.sliderItems.length - 2 ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth * 3;
      } else {
        var slideScrollPosition = this.currentPage === this.sliderItems.length - 3 ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth * 4;
      }
    } else {
      var slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    }
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(false, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.hideWarningMessage();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        // Update selected size display
        const selectedSizeElement = document.getElementById(`selected-size-${this.dataset.section}`);
        if (selectedSizeElement && this.currentVariant && this.currentVariant.option2) {
          selectedSizeElement.textContent = this.currentVariant.option2;
        }

        // Update last units display
        const elementId = `last-units-${this.dataset.section}`;
        const lastUnitsElement = document.getElementById(elementId);
        const isNewCollection = this.dataset.newCollection === 'true';
        console.log('Last units debug:', {
          elementId: elementId,
          element: lastUnitsElement,
          sectionId: this.dataset.section,
          variant: this.currentVariant,
          available: this.currentVariant?.available,
          stock: this.currentVariant?.inventory_quantity,
          isNewCollection: isNewCollection
        });
        if (this.currentVariant && this.currentVariant.available) {
          const stock = this.currentVariant.inventory_quantity;
          if (stock < 9 && stock > 0 && !isNewCollection) {
            console.log('Should show last units - removing hidden class');
            if (lastUnitsElement) {
              lastUnitsElement.classList.remove('hidden');
            }
          } else {
            console.log('Should hide last units - adding hidden class');
            if (lastUnitsElement) {
              lastUnitsElement.classList.add('hidden');
            }
          }
        } else {
          console.log('Variant not available - hiding last units');
          if (lastUnitsElement) {
            lastUnitsElement.classList.add('hidden');
          }
        }

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.addToCart);
      });
  }

  hideWarningMessage() {
    const productMessage = document.getElementById('ProductMessage');
    productMessage.style.display = 'none';
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const backStockButton = productForm.querySelector('#BIS_trigger');
    const availableDate = productForm.closest('.product__info-wrapper').querySelector('.product__available-date');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    let wrapperSize = document.querySelector(".product-form__input-wrapper.is-talla");

    // Get button text elements for dynamic switching
    const submitTextElement = addButton.querySelector('.product-submit__text');
    const submitSizeElement = addButton.querySelector('.product-submit__size');

    if (availableDate) {
      availableDate.classList.remove('first-load');
    }

    if (!addButton) return;

    if (disable) {
      if (backStockButton) {
        backStockButton.style.display = 'inline-block';
        if (wrapperSize) wrapperSize.classList.add("active");
        console.log('checking stock');
      }
      addButton.classList.add('isdisabled');
      if (text) addButtonText.textContent = text;
    } else {
      if (wrapperSize) wrapperSize.classList.remove("active");
      addButton.classList.remove('isdisabled');

      // Handle dynamic button text based on size selection and screen size
      this.updateButtonText(submitTextElement, submitSizeElement);
    }

    if (!modifyClass) return;
  }

  updateButtonText(submitTextElement, submitSizeElement) {
    if (!submitTextElement || !submitSizeElement) {
      // Fallback to legacy behavior if elements don't exist
      const addButtonText = document.querySelector('[name="add"] > span');
      if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
      return;
    }

    const hasSizeSelected = document.querySelector('.product-form__input.input--talla > input:checked');
    const hasSizeSelector = document.querySelector('.product-form__input-wrapper.is-talla');

    // If there's a size selector, show dynamic text based on selection
    if (hasSizeSelector) {
      if (hasSizeSelected) {
        // Show "Añadir al Carrito" (from product-submit__text)
        submitTextElement.classList.remove('hidden');
        submitSizeElement.classList.add('hidden');
      } else {
        // Show "Elige tu talla" (from product-submit__size)
        submitTextElement.classList.add('hidden');
        submitSizeElement.classList.remove('hidden');
      }
    } else {
      // No size selector: always show "Añadir al Carrito" (from product-submit__text)
      submitTextElement.classList.remove('hidden');
      submitSizeElement.classList.add('hidden');
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}


customElements.define('variant-radios', VariantRadios);

class CardQuickSizes extends HTMLElement {
  constructor() {
    super();
    this.id = `card-sizes-${Date.now()}`;
    this.currentProductId = undefined;
    this.moq = undefined;

    this.cardSizesRadios = this.querySelector(".card-product-form__radios");
    this.modal = this.querySelector(".card-form__inputs");
    this.modalClose = this.querySelector("[id*='modalClose'");
    this.cardSizesRadios.addEventListener('click', this.submitSize.bind(this));
    this.modalClose.addEventListener("click", this.closeModal.bind(this));

    const firstButton = document.querySelector('.product-card-wrapper .modal-opener');
    if (firstButton && window.getComputedStyle(firstButton)?.getPropertyValue("display") == "none") {
      document.addEventListener('mouseover', this.onHover.bind(this));
      document.addEventListener('mouseout',this.onMouseOut.bind(this));
    }
    document.addEventListener('click', this.onClick.bind(this), true);
    document.addEventListener('pagehide', (() => {
      this.returnToContainer();
    }).bind(this));
  }

  connectedCallback() {
    this.container = document.querySelector('#card-sizes-container');
    this.cartItems = document.querySelector('cart-items');
    this.footerCart = document.getElementById('main-cart-footer');
  }

  onClick(e) {
    const isSize = e.target.closest('#modalContent-card-sizes') !== null;
    const isModalOpener = e.target.closest('.modal-opener') !== null;
    const productCard = e.target.closest('.product-card-wrapper');

    if (!isSize && isModalOpener && productCard) {
      if (this.modal) {
        this.toogleModal(productCard, this.cardSizesRadios);
      }
    }else{
      this.returnToContainer();
    }
  }

  onHover(e) {
    if(e.target.closest('.drawer-cart__overlay') !== null) return;
    
    const productCard = e.target.closest('.product-card-wrapper');
    if (productCard?.classList.contains("product-card-recommendation")) return;
    const cardSizes = productCard?.querySelector('card-sizes');
    const isSameProduct = this.currentProductId == productCard?.dataset.productId;

    if (productCard && !cardSizes && !isSameProduct) {
      const cardSizesContainer = document.querySelector("card-sizes");
      if(!cardSizesContainer) return;
      productCard.querySelector(".card--product").prepend(cardSizesContainer);

      this.currentProductId = productCard.dataset.productId;
      this.moq = productCard.dataset.moq;
      this.showSizes(productCard, this.cardSizesRadios, false); 
    }
  }

  onMouseOut(e) {
    const productCard = e.target.closest('.product-card-wrapper');
    if (productCard?.classList.contains("product-card-recommendation")) return;
    const insideCardSizes = e.target.closest('card-sizes') != undefined && e.target.closest('card-sizes') != null;

    const keep = productCard || e.target.tagName == this.tagName || insideCardSizes;

    if(keep) return;

    this.returnToContainer();
  }

  toogleModal(productCard, cardSizesRadios) { 
    if(this.currentProductId == productCard.dataset.productId && 
      !this.classList.contains("toggle-hidden--pointer-coarse"))
      {
      this.closeModal();
      if (productCard.classList.contains("product-card-recommendation")) {
        this.returnToContainer();
      }
    }else{
      this.closeModal();
      setTimeout((() => {
        if (productCard.classList.contains("product-card-recommendation")) {
          const cardSizesContainer = document.querySelector("card-sizes");
          productCard.querySelector(".card--product").prepend(cardSizesContainer);
        }
        this.classList.remove("toggle-hidden--pointer-coarse");
        this.currentProductId = productCard.dataset.productId;
        this.moq = productCard.dataset.moq;
        this.showSizes(productCard, cardSizesRadios, true);
        document.addEventListener("click", this.handleOutsideClick.bind(this));
      }).bind(this), 500);
    }
  }

  closeModal() {
    this.classList.add("toggle-hidden--pointer-coarse");
    this.style.animation = "slidedown .2s forward";
    setTimeout(() => {
      this.returnToContainer();
    }, 200);
  }

  returnToContainer() {
    this.container.appendChild(this);
    this.currentProductId = undefined;
    this.moq = undefined;
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.closeModal();
    }

    document.removeEventListener("click", this.handleOutsideClick);
  }

  submitSize(event) {
    event.preventDefault();
    const eventTarget = event.target.closest(".card-product-form__radios-item").querySelector("input");
    const variantId = eventTarget.getAttribute('data-variant');
    if (!eventTarget.getAttribute("disabled")) {
      let quantity = 1;
      if (this.moq) quantity = parseInt(this.moq);
  
      const addData = {
        id: variantId,
        quantity: quantity,
        sections: this.cartItems.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      };

      fetch('/cart/add.js', {
        body: JSON.stringify(addData),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        method: 'POST',
      })
        .then((response) => response.json())
        .then((response) => {
          var settings = {
            speedOpen: 250,
            activeClass: 'is-active',
            visibleClass: 'is-visible',
          };

          var toggleccessibility = function (event) {
            if (event.getAttribute('aria-expanded') === 'true') {
              event.setAttribute('aria-expanded', false);
            } else {
              event.setAttribute('aria-expanded', true);
            }
          };
    
          var openDrawer = function (trigger) {
            var target = document.getElementById(trigger.getAttribute('aria-controls'));     
            target.classList.add(settings.activeClass);
            // document.documentElement.style.overflow = 'hidden';
            toggleccessibility(trigger);
      
            setTimeout(function () {
              target.classList.add(settings.visibleClass);
            }, settings.speedOpen);
          };
  
          openDrawer(eventTarget);
  
          this.cartItems.classList.remove('is-empty');
          this.footerCart.classList.remove('is-empty');
  
          const addToCartEvent = new CustomEvent("addedToCart", { detail: response });
          document.dispatchEvent(addToCartEvent);
            // inicio
            let variantID = document.querySelector('li[data-id="' + response.variant_id + '"]');
  
            if (variantID != null) {
              let variantLine = variantID.getAttribute('data-index');
              var line = variantLine;
            } else {
              var line = 1;
            }
            
            let quantity = response.quantity;
            const body = JSON.stringify({
              line,
              quantity,
              sections: this.cartItems.getSectionsToRender().map((section) => section.section),
              sections_url: window.location.pathname
            });
            fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
            .then((response) => response.json())
            .then((state) => {
              console.log('Product added to cart - Quicksize', response);
              Shopify.analytics.publish('product_added_to_cart_rtb', {
                offerId: `${Shopify.country}` + "-" + `${response.product_id}`,
              });
              const parsedState = state;
              this.cartItems.getSectionsToRender().forEach((section => {
                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
  
                elementToReplace.innerHTML =
                  this.cartItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
  
              }));
            
            }).catch((e) => {
              console.error(e);
            })
            // fin
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
        });
    }
  }
    
  showSizes(productCard, cardSizesRadios, isModal) {
    cardSizesRadios.innerHTML = "";
    const variantData = JSON.parse(productCard.dataset.variants);
    const optionData = JSON.parse(productCard.dataset.options);

    // Now, you can use find on optionDataArray
    const tallaOption = optionData.find(option => option.name.toLowerCase() === "talla" || option.name.toLowerCase() === "size");

    if(tallaOption)
    {
      this.classList.remove("card__sizes-default");
      this.classList.add("card__sizes-switcher");
      const tallaOptionPosition = tallaOption.position;
      tallaOption.values.forEach((size, index) => {
        const radioItem = document.createElement("div");
        radioItem.classList.add("card-product-form__radios-item");
    
        const radioInput = document.createElement("input");
        radioInput.type = "radio";
        radioInput.id = `${productCard.dataset.handle}-${tallaOptionPosition}-${index}`;
        radioInput.name = `${productCard.dataset.handle}-${tallaOption.name}`;
        radioInput.value = size;
        radioInput.setAttribute("form", `product-form-${productCard.dataset.handle}`);
        radioInput.setAttribute("aria-haspopup", "dialog");
        radioInput.setAttribute("aria-controls", "drawer-name");
  
        const matchingVariant = variantData.find(variant =>
          variant[`option${tallaOptionPosition}`] === size
        );
    
        if (matchingVariant) {
          radioInput.setAttribute("data-variant", matchingVariant.id);
          if (matchingVariant.available == false) {
            radioItem.classList.add("opt-sold-out");
            radioInput.setAttribute("disabled", "");
          }
        }
    
        const label = document.createElement("label");
        label.setAttribute("for", `${productCard.dataset.handle}-${tallaOptionPosition}-${index}`);
        label.innerHTML = `<span class="value">${size}</span>`;
    
        radioItem.appendChild(radioInput);
        radioItem.appendChild(label);
    
        cardSizesRadios.appendChild(radioItem);
      });
    } else{
      this.classList.remove("card__sizes-switcher");
      this.classList.add("card__sizes-default");
      //variante única
      const radioItem = document.createElement("div");
      radioItem.classList.add("card-product-form__radios-item");
  
      const radioInput = document.createElement("input");
      radioInput.type = "radio";
      radioInput.id = `${productCard.dataset.handle}-0-0`;
      radioInput.name = `${productCard.dataset.handle}-${variantData[0].title}`;
      radioInput.value = variantData[0].title;
      radioInput.setAttribute("form", `product-form-${productCard.dataset.handle}`);
      radioInput.setAttribute("aria-haspopup", "dialog");
      radioInput.setAttribute("aria-controls", "drawer-name");
  
      radioInput.setAttribute("data-variant", variantData[0].id);
      if (variantData[0].available == false) {
        radioItem.classList.add("opt-sold-out");
        radioInput.setAttribute("disabled", "");
      }
  
      const label = document.createElement("label");
      label.setAttribute("for", `${productCard.dataset.handle}-0-0`);
      label.innerHTML = `<span class="value">${window.variantStrings.addToCart}</span>`;
  
      radioItem.appendChild(radioInput);
      radioItem.appendChild(label);
  
      cardSizesRadios.appendChild(radioItem);
      if (isModal == true) {
        if (variantData[0].available == true) {
          radioItem.firstChild.click();
        }
      }
    }
  }
}

customElements.define('card-sizes', CardQuickSizes);

document.addEventListener('DOMContentLoaded', () => {
  let homepageUrl = '';
  if(window.location.href == 'https://ecoalf.com/de') {
    homepageUrl = 'https://ecoalf.com/de';
  } else if(window.location.href == 'https://ecoalf.com/fr') {
    homepageUrl = 'https://ecoalf.com/fr';
  } else if(window.location.href == 'https://ecoalf.com/en') {
    homepageUrl = 'https://ecoalf.com/en';
  } else {
    homepageUrl = 'https://ecoalf.com/';
  }

  if (window.location.href == homepageUrl) {
    const links = document.querySelectorAll('a');
    links.forEach((link) => {
      link.addEventListener('click', () => {
        const linkObject = {
          'link_text': link.innerText,
          'link_url': link.href
        }
        Shopify.analytics.publish("clics_home", linkObject );
      })
    })
  } 
})

// Initialize video intersection observer on DOM load
document.addEventListener('DOMContentLoaded', () => {
  initVideoIntersectionObserver();
});